enum MUI_PRO_LICENSE {
  Key = "5a43ed0d8170bf221e9ac90e6ee5febaTz01NjM1OCxFPTE3MDMwNDQ3NjM4NjIsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
}

export const MUI_PRO_LICENSE_KEY = MUI_PRO_LICENSE.Key